import { createMuiTheme } from '@material-ui/core/styles';
// Developed using the style guide at:
// https://projects.invisionapp.com/d/main?origin=v7#/projects/prototypes/13888045?scrollOffset=600

const palette = {
  primary: {
    main: '#AE2125'
  },
  secondary: {
    main: '#4d4d4d'
  },
  text: {
    primary: '#000000',
    secondary: '#757575',
    disabled: '#bdbdbd'
  },
  background: {
    default: '#ffffff'
  }
};

const typography = {
  fontFamily: '"Open Sans", "Helvetica Neue", sans-serif',
  button: {
    textTransform: null,
    fontWeight: 550
  },
  caption: {
    fontSize: '0.875rem'
  }
};

const shape = {
  borderRadius: 6
};

const onlinePajakMuiTheme = createMuiTheme({
  palette,
  typography,
  shape
});

export default onlinePajakMuiTheme;
